var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent_container",attrs:{"id":"fy_intr"}},[_c('h2',{staticClass:"text-center"},[_vm._v("无缝对接你的所有软件")]),_vm._v(" "),_c('h4',{staticClass:"text-center"},[_vm._v("\n    极其精简API接口对接服务，一天即可完成对接。一次对接，所有设备可用，省时省心省力。\n  ")]),_vm._v(" "),_c('fy_view_pdf',{staticClass:"fy_view",attrs:{"pdf-index":_vm.pdfIndex}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f86f932e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fy_intr.vue
// module id = null
// module chunks = 